import { Component } from '@angular/core';
import { AuthService, User } from '../../auth/auth.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

interface Module{
  name: string;
  children: MenuItem[]
};

interface MenuItem{
  name: string;
  route: string;
  iconUrl: string;
}

@Component({
  selector: 'app-navigation',
  standalone: false,
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent {

  user!: User;
  organisationIconUrl:string = '';
  private navigationModulesSub!: Subscription;
  modules: Module[] = [];
  showUserDropdown: boolean = false;

  private routes:any = {
    'MFG-FREIGHT_QUOTE': '/manufacturer/rfq',
    'MFG-SPOT_AUCTION': '/mfg/spot-auction',
    'MFG-CONTRACT_AUCTION': '/manufacturer/bids/contract-bid',
    'MFG-TRANSPORTERS': '/manufacturer/transporters',
    'MFG-GATE_MANAGEMENT': '/manufacturer/vehicle-gate-management',
    'MFG-INDENT_MGMT': '/manufacturer/indent-management',
    'MFG-COUNTER_OFFER': '/manufacturer/counter-offer',
    'MFG-FREIGHT_PAY': '/manufacturer/invoicing-payments',
    'MFG-FREIGHT_CONTRACT': '/manufacturer/contract-management',
    'MFG-SETTINGS': '/manufacturer/manage-organization',
    'MFG-STAR_DASHBOARD': '/manufacturer/green-logistics',
    'MFG-INDENT_MGMT_GATE': '/manufacturer/vehicle-inwarding',
    'MFG-INDENTS': '/manufacturer/indent-management/v2',
    'MFG-CONSIGNMENTS': '/manufacturer/ewb-aggregation-system',
    'MFG-ANALYTICS': '/manufacturer/analytics',
    'MFG-FREIGHT_IQ': '/manufacturer/freight-Intelligence',
    'MFG-PRIMARY_TRIP_MGMT': '/manufacturer/trip-management',
    'MFG-SECONDARY_TRIP_MGMT': '/manufacturer/secondary-trip-management',
    'MFG-VEHICLES_INFO': '/manufacturer/vehicles-information',
    'MFG-CONTROL_TOWER': '/manufacturer/control-tower',
    'MFG-REPORTS': '/manufacturer/reports',
    'MFG-ULIP_DASHBOARD': '/manufacturer/ulip-dashboard',
    'MFG-TPT_PERFORMANCE': '/manufacturer/tp-performance',
    'MFG-TPT_FINANCIAL_RISK_PROFILE': '/manufacturer/tp-financial-risk-profile',
    'MFG-GREEN_LOGISTICS(OLD)': '/manufacturer/green-logistics-v1',
  };

  constructor(
    private authService: AuthService,
    private route: Router,
  ){}

  ngOnInit(){
    this.user = this.authService.user;
    this.organisationIconUrl = this.user.organization.iconUrl;

    this.navigationModulesSub = this.authService.navigationModules$.subscribe((modules:any) => {
      if(modules?.['userModuleAccessGroups']){
        this.setNavigation(modules);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.navigationModulesSub) {
      this.navigationModulesSub.unsubscribe();
    }
  }

  private setNavigation(navModules:any){
    if(navModules.groupedUserSiteModules){
      navModules.groupedUserSiteModules.forEach((groupedSiteModule:any) => {
        let menuItems:MenuItem[] = [];
        if(groupedSiteModule.siteModules){
          groupedSiteModule.siteModules.forEach((siteModule:any) => {
            if(siteModule.isEnabled){
              let menutItem:MenuItem = {
                name: siteModule.siteModuleName,
                route: this.routes[siteModule['siteModule']] ?? '',
                iconUrl: siteModule.siteModuleIconUrl ?? '/assets/icons/add-settings.svg'
              };
              menuItems.push(menutItem)
            }
          });
        }
        if(menuItems.length > 0){
          let module:Module = {
            name: groupedSiteModule['name'],
            children: menuItems
          };
          this.modules.push(module);
        }
      });
    }
  }

  toggleUserDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.showUserDropdown = !this.showUserDropdown;
    
    if (this.showUserDropdown) {
      // Add click listener to close dropdown when clicking outside
      setTimeout(() => {
        document.addEventListener('click', this.closeUserDropdown);
      });
    }
  }

  closeUserDropdown = () => {
    this.showUserDropdown = false;
    document.removeEventListener('click', this.closeUserDropdown);
  }

  logout() {
    // todo logout
  }

  navigateTo(route:string){
    this.route.navigate([route]);
  }

  private navigateToOldPlatform(){

  }

  private navigateToComponent(){

  }

}
